import { render } from "./article-overview.vue?vue&type=template&id=459f59f8"
import script from "./article-overview.vue?vue&type=script&lang=js"
export * from "./article-overview.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Cfcu.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__